import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "ecertnl-base-block",
  templateUrl: "./ecertnl-base-block.component.html",
  styleUrls: ["./ecertnl-base-block.component.css"],
  standalone: false,
})
export class EcertBaseBlockComponent {
  @Input() ref_object: any;
  @Input() property: string;
  @Input() label: string;
  @Input() tooltip: string;
  @Input() container_class: string;
  @Input() placeholder: string;
  @Input() action_identifier: string;
  @Input() maxlength: number;

  @Input() hideLabel: boolean = false;

  @Input() error: boolean = false;
  @Input() foutmelding: string;

  _disabled: boolean = false;
  _wijzigbaar: boolean = false;

  @Input()
  public set disabled(disabled: boolean) {
    this._disabled = disabled;
  }

  public get disabled() {
    if (
      this.ref_object == undefined ||
      typeof this.ref_object.muteerbaar == "undefined"
    ) {
      return this._disabled;
    } else {
      return (
        this._disabled ||
        !this.ref_object.muteerbaar ||
        (this.ref_object.eedOpSlot && !this.wijzigbaar)
      );
    }
  }

  get wijzigbaar(): boolean {
    if (this.action_identifier == undefined) {
      return this._wijzigbaar;
    }
    return true;
  }

  @Input()
  set wijzigbaar(wijzigbaar: boolean) {
    this._wijzigbaar = wijzigbaar;
  }

  _required: boolean;
  @Input()
  public set required(required: boolean) {
    this._required = required;
  }

  public get required() {
    return this._required;
  }

  public get verplicht(): boolean {
    if (this.required == null) {
      return false;
    } else {
      return this.required;
    }
  }

  @Output()
  public onChange = new EventEmitter();

  constructor() {}

  public componentChanged(adres) {
    this.onChange.emit(adres);
  }

  public hasErrors() {
    console.error("hasErrors is voor dit component niet gedefinieerd");
    return false;
  }
}
